// extracted by mini-css-extract-plugin
module.exports =  {"container":"SearchInput-module_container_e3e2a","tags":"SearchInput-module_tags_a3ade","item":"SearchInput-module_item_a27e5"};